import { Reducer } from 'redux'
import { generateUniqueKey, generateUniqueKeyWithNoPrefix } from '../../helpers'
import { NewContractProduct } from '../../pages/contracts/contracts.model'
import { ClientsActionTypes } from '../actions/clients.actions'
import { ClientsStoreModel, initialClientsStoreState } from '../store.model'
import { updateTempList } from '../helpers'
import { ContractModel } from '../../api/Argentia/model/contracts'
import { FlexibilitiesModel } from '../../api/Argentia/endpoints/flexibilities/model/flexibilities'

export const clientsReducer: Reducer<ClientsStoreModel> = (
  state = initialClientsStoreState,
  action
) => {
  switch (action.type) {
    case ClientsActionTypes.FETCH_CLIENT_START:
      return { ...state, isFetchingClientData: true }
    case ClientsActionTypes.FETCH_CLIENT_END:
      return { ...state, isFetchingClientData: false }
    case ClientsActionTypes.FETCH_CLIENT_ERROR:
      return { ...state, isFetchingClientDataError: true }
    case ClientsActionTypes.FETCH_CONTRACTS_START:
      return { ...state, isFetchingClientContracts: true }
    case ClientsActionTypes.FETCH_CONTRACTS_END:
      return { ...state, isFetchingClientContracts: false }
    case ClientsActionTypes.FETCH_CONTRACTS_ERROR:
      return { ...state, isFetchingClientContractsError: true }
    case ClientsActionTypes.FETCH_CONTRACT_START:
      return { ...state, isFetchingContract: true }
    case ClientsActionTypes.FETCH_CONTRACT_END:
      return { ...state, isFetchingContract: false }
    case ClientsActionTypes.FETCH_CONTRACT_ERROR:
      return { ...state, isFetchingContractError: true }
    case ClientsActionTypes.FETCH_CONTRACT_PRODUCTS_START:
      return { ...state, isFetchingContractProducts: true }
    case ClientsActionTypes.FETCH_CONTRACT_PRODUCTS_END:
      return { ...state, isFetchingContractProducts: false }
    case ClientsActionTypes.FETCH_CONTRACT_PRODUCTS_ERROR:
      return {
        ...state,
        isFetchingContractProductsError: true,
        contractProducts: null,
        contractProductsTemp: null
      }
    case ClientsActionTypes.FETCH_COMMERCIALS_START:
      return { ...state, isFetchingClientCommercials: true }
    case ClientsActionTypes.FETCH_COMMERCIALS_END:
      return { ...state, isFetchingClientCommercials: false }
    case ClientsActionTypes.FETCH_COMMERCIALS_ERROR:
      return { ...state, isFetchingClientCommercialsError: true }
    case ClientsActionTypes.FETCH_COUNTRIES_START:
      return { ...state, isFetchingCountries: true }
    case ClientsActionTypes.FETCH_COUNTRIES_END:
      return { ...state, isFetchingCountries: false }
    case ClientsActionTypes.FETCH_COUNTRIES_ERROR:
      return { ...state, isFetchingCountriesError: true }
    case ClientsActionTypes.FETCH_PROVINCES_START:
      return { ...state, isFetchingProvinces: true }
    case ClientsActionTypes.FETCH_PROVINCES_END:
      return { ...state, isFetchingProvinces: false }
    case ClientsActionTypes.FETCH_PROVINCES_ERROR:
      return { ...state, isFetchingProvincesError: true }
    case ClientsActionTypes.FETCH_MUNICIPALITIES_START:
      return { ...state, isFetchingMunicipalities: true }
    case ClientsActionTypes.FETCH_MUNICIPALITIES_END:
      return { ...state, isFetchingMunicipalities: false }
    case ClientsActionTypes.FETCH_MUNICIPALITIES_ERROR:
      return { ...state, isFetchingMunicipalitiesError: true }
    case ClientsActionTypes.STORE_COUNTRIES:
      return { ...state, countries: action.payload, isFetchingCountriesError: false }
    case ClientsActionTypes.STORE_PROVINCES:
      return { ...state, provinces: action.payload, isFetchingProvincesError: false }
    case ClientsActionTypes.STORE_MUNICIPALITIES:
      return { ...state, municipalities: action.payload, isFetchingMunicipalitiesError: false }
    case ClientsActionTypes.STORE_SEARCH_TEXT:
      return { ...state, searchText: action.payload }
    case ClientsActionTypes.STORE_CLIENT_DATA:
      return { ...state, clientData: action.payload, isFetchingClientDataError: false }
    case ClientsActionTypes.STORE_CLIENT_CONTRACTS:
      return { ...state, clientContracts: action.payload, isFetchingClientContractsError: false }
    case ClientsActionTypes.STORE_CLIENT_COMMERCIALS:
      return {
        ...state,
        clientCommercials: action.payload,
        isFetchingClientCommercialsError: false
      }
    case ClientsActionTypes.STORE_CONTRACT_PRODUCTS:
      return {
        ...state,
        contractProducts: action.payload,
        contractProductsTemp: action.payload,
        isFetchingContractProductsError: false
      }
    case ClientsActionTypes.STORE_ACTIVE_CONTRACT:
      return {
        ...state,
        activeContract: action.payload as ContractModel
      }
    case ClientsActionTypes.STORE_ACTIVE_FLEXIBILITY:
      return {
        ...state,
        activeFlexibility: action.payload as FlexibilitiesModel
      }
    case ClientsActionTypes.CLEAR_ACTIVE_CONTRACT:
      return {
        ...state,
        activeContract: null
      }
    case ClientsActionTypes.CLEAR_ACTIVE_FLEXIBILITY:
      return {
        ...state,
        activeFlexibility: null
      }
    case ClientsActionTypes.TEMP_ADD_CONTRACT_PRODUCT:
      return {
        ...state,
        contractProductsTemp: addNewProductTempList(
          action.payload,
          state.contractProductsTemp ?? []
        )
      }
    case ClientsActionTypes.TEMP_UPDATE_CONTRACT_PRODUCT:
      return {
        ...state,
        contractProductsTemp: updateTempList(action.payload, state.contractProductsTemp ?? [])
      }
    case ClientsActionTypes.TEMP_REMOVE_CONTRACT_PRODUCT:
      return {
        ...state,
        contractProductsTemp: removeProductTempList(
          action.payload,
          state.contractProductsTemp ?? []
        )
      }
    case ClientsActionTypes.STORE_CLIENT_CONTRACT:
      return {
        ...state,
        clientContracts: updateContractList(action.payload, state.clientContracts),
        activeContract: action.payload
      }
    case ClientsActionTypes.UPDATE_CLIENT_CONTRACT:
      return {
        ...state,
        clientContracts: editContract(action.payload, state.clientContracts),
        activeContract: action.payload
      }
    case ClientsActionTypes.SET_DESACTIVE_CONTRACT:
      return {
        ...state,
        activeContract: undefined,
        contractProducts: undefined,
        contractProductsTemp: undefined
      }
    case ClientsActionTypes.CLEAR_CLIENT_DATA:
      return { ...state, clientData: undefined }
    case ClientsActionTypes.CLEAR_CLIENT_CONTRACTS:
      return { ...state, clientContracts: undefined }
    case ClientsActionTypes.CLEAR_CLIENT_COMMERCIALS:
      return {
        ...state,
        clientCommercials: undefined
      }
    case ClientsActionTypes.REMOVE_CLIENT_CONTRACT:
      return {
        ...state,
        clientContracts: removeContract(action.payload, state.clientContracts)
      }
    case ClientsActionTypes.SWITCH_COMM_CLIENT_FILE_OFF:
      return { ...state, showCommunicationFile: false }
    case ClientsActionTypes.SWITCH_COMM_CLIENT_ADD_OFF:
      return { ...state, showCommunicationAdd: false }
    case ClientsActionTypes.ACTIVE_TAB_ADITIONALS:
      return { ...state, activeTabAditionals: action.payload }
    default:
      return state
  }
}

const updateContractList = (contract: ContractModel, contracts?: ContractModel[]) => {
  const isNew = !contracts?.some(c => c.id === contract.id)
  return isNew ? addContract(contract, contracts) : editContract(contract, contracts)
}

const addContract = (newContract: ContractModel, contracts?: ContractModel[]): ContractModel[] => {
  if (contracts && contracts.length > 0) {
    const filteredList = contracts.filter(c => c.id !== newContract.id)
    return [...filteredList, newContract]
  } else {
    return [newContract]
  }
}

const editContract = (contract: ContractModel, contracts?: ContractModel[]): ContractModel[] => {
  if (contracts && contracts.length > 0) {
    return contracts.map(c => {
      if (c.id === contract.id) {
        return { ...contract, hasFlexibilities: c.hasFlexibilities, account: c.account }
      }
      return c
    })
  } else {
    return [contract]
  }
}

const removeContract = (
  newContract: ContractModel,
  contracts?: ContractModel[]
): ContractModel[] | undefined => {
  return contracts && contracts.length > 0
    ? contracts.filter(contract => contract.id !== newContract.id)
    : contracts
}

const setContractAsActive = (
  id: number,
  contracts?: ContractModel[]
): ContractModel | undefined => {
  return contracts && contracts.length > 0 ? contracts.find(c => c.id === id) : undefined
}

// CRUD ContractProducts to assist /Contracts/edit product's table
const addNewProductTempList = (product: NewContractProduct, productsList: NewContractProduct[]) => {
  const newProduct: NewContractProduct = {
    ...product,
    tempId: generateUniqueKeyWithNoPrefix()
  }
  return [...productsList, newProduct]
}

// Remove from list (if product has id, triggers DELETE API, else only remove recently added product (tempId))
const removeProductTempList = (itemId: string | number, productsList: NewContractProduct[]) => {
  return productsList.filter(p => !(itemId === p.tempId || itemId === p.id))
}
